export type PatientHistoryDTO = Partial<{
	pid: string;
	studyInstanceUID: string;
	patientName: string;
	studyDate: string;
	studyTime: string;
	modalityType: string;
	description: string;
	bodyPart: string;
	accessionNumber: string;
	id: string;
}>;

export type PatientHistoryFilter = {
	patientID: string;
} & Partial<{
	startDate: string;
	endDate: string;
	accessionNumber: string;
	patientName: string;
	modalityTypes: string;
	studyInstanceUID: string;
}>;
